import React from 'react';
import classes from './TableComponent.module.css';
export const Checkbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <React.Fragment>
      <input className={``} type="checkbox" ref={resolvedRef} {...rest} />
    </React.Fragment>
  );
});
